// third party imports
import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// internal rebet imports
import './stylesUserManager.css'
import { NAVIGATION_ROUTES } from '../../../utils/NavigationUtils';
import { USER_HEADER_TABS } from '../../../utils/Constants';
import { SIDER_TABS } from '../../../utils/Constants';
import { fetchSpecificUsersData } from '../../../api/CommonFunctions/CommonFunctions';
import createPrivateAdminPanelInstance from '../../../api/PrivateAdminPanelInstance';

// component imports
import Sider from '../../CommonComponents/Sider/Sider';
import Header from '../../CommonComponents/Header/Header';
import UserManagerHeader from './UserManagerHeader/UserManagerHeader';
import UserActions from './UserActions/UserActions';
import UserData from './UserData/UserData';
import UserStatuses from './UserStatuses/UserStatuses';
import EditWalletPopup from './UserActions/ActionPopups/EditWalletPopup/EditWalletPopup';
import SuspendUserPopUp from './UserActions/ActionPopups/SuspendUserPopup/SuspendUserPopup';
import ToggleACHPopup from './UserActions/ActionPopups/ToggleAchPopup/ToggleACHPopup';
import EditUserDataPopup from './UserActions/ActionPopups/EditUserDataPopup/EditUserDataPopup';
import DeleteUserPopup from './UserActions/ActionPopups/DeleteUserPopup/DeleteUserPopup';
import PaymentInstrumentsPopup from './UserActions/ActionPopups/PaymentInstrumentsPopup/PaymentInstrumentsPopup';
import BetTable from './BetsTable/BetTable';
import TransactionTable from './TransactionsTable/TransactionTable';

// asset imports
import { ArrowLeft } from 'react-feather';
import DepositAttempts from '../../KPIs/Transactions/DepositAttempts/DepositAttempts';
import PersonalLimitsPopup from './UserActions/ActionPopups/PersonalLimitsPopup/PersonalLimitsPopup';
import Layout from '../../CommonComponents/Layout/Layout';
import FreeBetsPopup from './UserActions/ActionPopups/FreeBetsPopup/FreeBetsPopup';
import ProfitBoostPopup from './UserActions/ActionPopups/ProfitBoostPopup/ProfitBoostPopup';
import AltOddsTable from './AltOddsTable/AltOddsTable';
import AvailablePromotionsPopup from './UserActions/ActionPopups/AvailablePromotionsPopup/AvailablePromotionsPopup';
import CreditCardsPopup from './UserActions/ActionPopups/CreditCardsPopup/CreditCardsPopup';
import CasinoBetsTable from './CasinoBetsTable/CasinoBetsTable';
import AppStoreWrittenReviewPopup from './UserActions/ActionPopups/AppStoreWrittenReviewPopup/AppStoreWrittenReviewPopup';
import GamePassTogglePopup from './UserActions/ActionPopups/GamePassTogglePopup/GamePassTogglePopup';
import GlobalChatTogglePopup from './UserActions/ActionPopups/GlobalChatTogglePopup/GlobalChatTogglePopup';
import Poker from './Poker/Poker';
import GamePass from './GamePass/GamePass';
import { API_ROUTES } from '../../../api/ApiRoutes';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const UserManager = () => {
  // non-state variables
  const navigate = useNavigate();
  const location = useLocation();
  
  const query = useQuery();
  const tabFromUrl = query.get('tab');

  const { state } = useLocation();  
  const token = JSON.parse(localStorage.getItem('token'));
  const email = JSON.parse(localStorage.getItem("email"));
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(token?.IdToken);

  // state variables

  const [userData, setUserData] = useState(null);
  const [walletActive, setWalletActive] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  
  const [selectedTab, setSelectedTab] = useState(USER_HEADER_TABS?.OVERVIEW)
  const [isEditWalletPopupVisible, setIsEditWalletPopupVisible] = useState(false)
  const [isSuspendUserPopupVisible, setIsSuspendUserPopupVisible] = useState(false)
  const [isToggleACHPopupVisible, setIsToggleACHPopupVisible] = useState(false)
  const [isDeleteUserPopupVisible, setIsDeleteUserPopupVisible] = useState(false)
  const [isEditUserDataPopupVisible, setIsEditUserDataPopupVisible] = useState(false)
  const [isPersonalLimitsPopupVisible, setIsPersonalLimitsPopupVisible] = useState(false)
  const [isAvailablePromotionsPopupVisible, setIsAvailablePromotionsPopupVisible] = useState(false)
  const [isFreeBetPopupVisible, setIsFreeBetPopupVisible] = useState(false)
  const [isProfitBoostPopupVisible, setIsProfitBoostPopupVisible] = useState(false)
  const [isPaymentInstrumentsPopupVisible, setIsPaymentInstrumentsPopupVisible] = useState(false)
  const [isCreditCardsPopupVisible, setIsCreditCardsPopupVisible] = useState(false)
  const [upToDateUserData, setUpToDateUserData] = useState(false)
  const [isAppStoreWrittenReviewPopupVisible, setIsAppStoreWrittenReviewPopupVisible] = useState(false)
  const [isGamePassTogglePopupVisible, setIsGamePassTogglePopupVisible] = useState(false)
  const [isGlobalChatTogglePopupVisible, setIsGlobalChatTogglePopupVisible] = useState(false)


  // use effects
  useEffect(() => {
    setUpToDateUserData(userData)
  }, [userData])

  useEffect(() => {
    if (walletActive) {
      setIsEditWalletPopupVisible(true)
    }
  }, [walletActive])

  useEffect(() => {
    console.log("tabFromUrl", tabFromUrl);
    if (tabFromUrl && Object.values(USER_HEADER_TABS).includes(tabFromUrl.toLowerCase())) {
      setSelectedTab(tabFromUrl.toLowerCase());
    }
  }, [tabFromUrl]);

  useEffect(() => {
    if (state?.user_data) {
      setUserData(state.user_data);
      setWalletActive(state.wallet_active);
    } else {
      const storedUser = localStorage.getItem("selected_user_data");
      const storedWalletActive = localStorage.getItem("wallet_active");

      if (storedUser) {
        setUserData(JSON.parse(storedUser));
        setWalletActive(storedWalletActive === "true");

        localStorage.removeItem("selected_user_data");
        localStorage.removeItem("wallet_active");
      }
    }
  }, [state]);

  // api functions
  const refreshUserData = async () => {
    const newest_data = await fetchSpecificUsersData(
      PrivateAdminPanelInstance,
      upToDateUserData?.user_id
    )

    setUpToDateUserData(newest_data)
    
    // Update the location state
    navigate(location.pathname + location.search, {
      state: {
        user_data: newest_data,
        wallet_active: newest_data.wallet_active
      },
      replace: true
    })
  }

  // helper functions
  const handleBackPressed = () => {
    navigate(-1);
  }

  const handleSetSelectedTab = (tab) => {
    setSelectedTab(tab)
  }

  const getAdmins = async () => {

    try {
      const response = await PrivateAdminPanelInstance?.post(
        API_ROUTES?.GET_ADMINS
      );

      const data = response?.data.data;

      
      const currentUser = data.find((admin) => admin.email === email);
      
      const isSuperAdmin = currentUser?.group_name === "super-admin-v2";
      console.log("isSuperAdmin ", email, isSuperAdmin);

      setIsSuperAdmin(isSuperAdmin);

    } catch (error) {
      console.log("error getting admins", error);
    }
  };

  useEffect(() => {
    getAdmins();
  }, []);

  return (
    <Layout>
      <div className='panel-container'>

        <UserManagerHeader
          selectedTab={selectedTab}
          setSelectedTab={handleSetSelectedTab}
        />

        <div className="body-container">

          <EditWalletPopup
            isVisible={isEditWalletPopupVisible}
            onClosePressed={() => setIsEditWalletPopupVisible(false)}
            userData={upToDateUserData}
            refreshUserData={refreshUserData}
          />

          <SuspendUserPopUp
            isVisible={isSuspendUserPopupVisible}
            onClosePressed={() => setIsSuspendUserPopupVisible(false)}
            userData={upToDateUserData}
            refreshUserData={refreshUserData}
          />

          <ToggleACHPopup
            isVisible={isToggleACHPopupVisible}
            onClosePressed={() => setIsToggleACHPopupVisible(false)}
            userData={upToDateUserData}
            refreshUserData={refreshUserData}
          />

          <EditUserDataPopup
            isVisible={isEditUserDataPopupVisible}
            onClosePressed={() => setIsEditUserDataPopupVisible(false)}
            userData={upToDateUserData}
            refreshUserData={refreshUserData}
            isSuperAdmin={isSuperAdmin}
          />


          <PersonalLimitsPopup
            isVisible={isPersonalLimitsPopupVisible}
            userId={upToDateUserData?.user_id}
            onClosePressed={() => setIsPersonalLimitsPopupVisible(false)}
          />
          
          <AvailablePromotionsPopup
            isVisible={isAvailablePromotionsPopupVisible}
            userId={upToDateUserData?.user_id}
            onClosePressed={() => setIsAvailablePromotionsPopupVisible(false)}
          />

          <CreditCardsPopup
            isVisible={isCreditCardsPopupVisible}
            userId={upToDateUserData?.user_id}
            onClosePressed={() => setIsCreditCardsPopupVisible(false)}
          />

          <PaymentInstrumentsPopup
            isVisible={isPaymentInstrumentsPopupVisible}
            onClosePressed={() => setIsPaymentInstrumentsPopupVisible(false)}
            userData={upToDateUserData}
          />

          <FreeBetsPopup
            isVisible={isFreeBetPopupVisible}
            onClosePressed={() => setIsFreeBetPopupVisible(false)}
            userData={upToDateUserData}
          />

          <ProfitBoostPopup
            isVisible={isProfitBoostPopupVisible}
            onClosePressed={() => setIsProfitBoostPopupVisible(false)}
            userData={upToDateUserData}
          />

          <DeleteUserPopup
            isVisible={isDeleteUserPopupVisible}
            onClosePressed={() => setIsDeleteUserPopupVisible(false)}
            userData={upToDateUserData}
            refreshUserData={refreshUserData}
          />

            <AppStoreWrittenReviewPopup
              isVisible={isAppStoreWrittenReviewPopupVisible}
              onClosePressed={() => setIsAppStoreWrittenReviewPopupVisible(false)}
              userData={upToDateUserData}
              userId={upToDateUserData?.user_id}
            />

          <GamePassTogglePopup
            isVisible={isGamePassTogglePopupVisible}
            onClosePressed={() => setIsGamePassTogglePopupVisible(false)}
            userData={upToDateUserData}
            userId={upToDateUserData?.user_id}
          />

          <GlobalChatTogglePopup
            isVisible={isGlobalChatTogglePopupVisible}
            onClosePressed={() => setIsGlobalChatTogglePopupVisible(false)}
            userData={upToDateUserData}
            userId={upToDateUserData?.user_id}
          />

          {
            selectedTab === USER_HEADER_TABS?.OVERVIEW
              ? (
                <>
                  <UserData
                    data={upToDateUserData}
                  />

                  <UserActions
                    userData={upToDateUserData}
                    onManageMoneyPressed={() => setIsEditWalletPopupVisible(true)}
                    onSuspendUserPressed={() => setIsSuspendUserPopupVisible(true)}
                    onToggleACHPressed={() => setIsToggleACHPopupVisible(true)}
                    onEditUserDataPressed={() => setIsEditUserDataPopupVisible(true)}
                    onEditPersonalLimitsPressed={() => setIsPersonalLimitsPopupVisible(true)}
                    onEditFreeBetPressed={() => setIsFreeBetPopupVisible(true)}
                    onEditProfitBoostPressed={() => setIsProfitBoostPopupVisible(true)}
                    onPaymentInstrumentsPressed={() => setIsPaymentInstrumentsPopupVisible(true)}
                    onEditAvailablePromotionsPressed={() => setIsAvailablePromotionsPopupVisible(true)}
                    onEditCreditCardsPressed={() => setIsCreditCardsPopupVisible(true)}
                    onDeleteUserPressed={() => setIsDeleteUserPopupVisible(true)}
                    onAppStoreWrittenReviewPressed={() => setIsAppStoreWrittenReviewPopupVisible(true)}
                    onGamePassTogglePressed={() => setIsGamePassTogglePopupVisible(true)}
                    onGlobalChatTogglePressed={() => setIsGlobalChatTogglePopupVisible(true)}
                  />

                  <UserStatuses
                    data={upToDateUserData}
                  />
                </>
              )
              : selectedTab === USER_HEADER_TABS?.BETS
                ? (
                  <BetTable
                    userData={upToDateUserData}
                  />
                )
                : selectedTab === USER_HEADER_TABS?.CASINO_BETS
                ? (
                  <CasinoBetsTable
                    userData={upToDateUserData}
                  />
                )
                : selectedTab === USER_HEADER_TABS?.POKER_BETS
                ? (
                  <Poker
                    userData={upToDateUserData}
                  />
                )
                : selectedTab === USER_HEADER_TABS?.GAME_PASS
                ? (
                  <GamePass
                    userData={upToDateUserData}
                  />
                )
                : selectedTab === USER_HEADER_TABS?.TRANSACTIONS
                ? ( 
                <div className='wallet-container'>
                  <TransactionTable userData={upToDateUserData} />
                </div>
                ) : (
                  <AltOddsTable user_id={upToDateUserData?.user_id} />
                )

          }


        </div>

      </div>
    </Layout>
  );
};

export default UserManager;